export default __webpack_public_path__ + "static/media/s1.88493bc8.jpg";